import { Component, OnInit } from '@angular/core';
import { SummaryPaymentModel } from './summaryPaymentModel';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'lib-operation-summary',
  templateUrl: './operation-summary.component.html',
  styleUrls: ['./operation-summary.component.scss']
})
export class OperationSummaryComponent implements OnInit {

  summaryPayment!: SummaryPaymentModel;
  checkingData: boolean = true;
  modalRef!: NgbModalRef;

  constructor() { }

  ngOnInit(): void {
  }

  closeModal() {
    this.modalRef.close();
  }
  openAuthSystem() {}
}
